import { ICataloguesProductsPosition } from 'stores/brands/types';

export const IMAGE_WIDTH = 720;
export const IMAGE_HEIGHT = 1080;
export const PRODUCT_IMAGE_SIZE = 80;
export const MAX_MENU_HEIGHT = (PRODUCT_IMAGE_SIZE + 16) * 4; // 16 - padding; 4 - items to show
export const DEFAULT_PRODUCT_POSITION: ICataloguesProductsPosition = {
  top: 0,
  left: 0,
  width: 10,
  height: 10,
};
